import { useEffect, useState } from 'react';
import { GetServerSideProps } from 'next';
import { MemberTimeProvider } from 'lowcode/utils/context/memberTimeZone';
import MemberGloData from 'lowcode/utils/MemberGloData';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import ShareCompoment from '@/components/Referral/Share';
import { ReferralProvider } from '@/components/Referral/ReferralProvider';
import SEOlinksA from '@/components/SEOlinksA';
import efBridge from '@/utils/JSBridge';
import { onLogin } from '@/utils/cookie';
import CountDown from '@/components/Referral/Common/CountDown';
import { getAppSession } from '@/utils/appGetToken';
import { IPageStatus } from '@/components/Referral/config/IPageStatus';

type ReferralProp = {
    SEO?: any;
    isLogin: boolean;
    timeLine: object;
    pageStatus: IPageStatus;
    systemTime: number | null;
};

const Referral: React.FC<ReferralProp> = ({ SEO, isLogin, timeLine, pageStatus, systemTime }) => {
    const { useLang, useRouter, isApp } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('referral');
    const [login, setLogin] = useState(isLogin);
    const initInfo = () => {
        efBridge.init();
        // 设置app导航
        efBridge?.callHandler('setPageConfig', {
            showNav: 1, // 显示导航栏
            topStartFrom: 0, // 在导航栏以下显示H5
            navigationBarBackgroundColor: '#000', //设置背景色
            navigationBarTextColor: '#FFFFFF', // 设置导航栏字体色,
        });
        if (isApp) {
            setLogin(true);
            // efBridge.registerHandler('getAppMsg', (res) => {
            //     if (!res) return;
            //     const dataSet = {
            //         token: res.token.replace('Bearer ', ''),
            //         user: {},
            //     };
            //     onLogin(dataSet);
            // });
            const token = getAppSession();
            const dataSet = {
                token,
                user: {},
            };
            onLogin(dataSet);
        }
    };

    useEffect(() => {
        initInfo();
    }, []);

    return (
        <>
            <SEO title={t('seo.title')} description={t('seo.desc')} />
            <SEOlinksA locale={locale} list={['eu', 'it', 'es', 'fr', 'de']} pathname={'referral'} />
            <PageLayout hideFooter={isApp} hideHeader={isApp}>
                <MemberTimeProvider>
                    <MemberGloData isOpenA={true} />
                    <ReferralProvider state={{ pageUsing: 'd3ms' }}>
                        <ShareCompoment isLogin={login} pageStatus={pageStatus} />
                    </ReferralProvider>
                </MemberTimeProvider>
            </PageLayout>
        </>
    );
};

export default Referral;

export const getServerSideProps: GetServerSideProps = async ({ locale, req, query }) => {
    const { debug, _timer } = query;
    const whiteLocaleList = ['eu', 'it', 'es', 'fr', 'de'];
    if (!whiteLocaleList.includes(locale as string)) {
        return { notFound: true };
    }
    // 获取登陆信息
    const userInfoJson = req.cookies?.userInfo || '';
    let isLogin = false;
    try {
        const userInfo = JSON.parse(userInfoJson);
        isLogin = !!userInfo.token;
    } catch {}

    let data = null;
    try {
        data = require(`src/components/Referral/config/times/${locale}.js`);
    } catch (err) {
        data = require(`src/components/Referral/config/times/jp.js`);
    }
    const timeLine = data.timeLine || null; // 代码保存的时间线
    let systemTime = new Date().getTime(); // 系统时间
    if (_timer) {
        // 读取url上的时间进行测试
        const _timer2 = `${_timer} GMT+8`;
        systemTime = new Date(_timer2).getTime();
    }

    // 当前页面阶段
    let pageStatus = '';
    if (debug) {
        // 是否进入调试状态
        pageStatus = debug as any;
    } else if (timeLine) {
        if (systemTime >= timeLine?.statusD?.start) {
            // 系统时间进入 statusC 时间段
            pageStatus = IPageStatus.statusD;
        } else if (systemTime >= timeLine?.statusC?.start) {
            // 系统时间进入 statusC 时间段
            pageStatus = IPageStatus.statusC;
        } else if (systemTime >= timeLine?.statusB?.start) {
            // 系统时间进入 statusB 时间段
            pageStatus = IPageStatus.statusB;
        } else if (systemTime >= timeLine?.statusA?.start) {
            // 系统时间进入 statusA 时间段
            pageStatus = IPageStatus.statusA;
        }
    }

    return {
        props: {
            isLogin,
            systemTime,
            timeLine: timeLine,
            debug: debug || '',
            pageStatus: pageStatus,
        },
    };
};
